export default __webpack_public_path__ + "static/media/EditDocumentIcon.0597bd49.svg";